import { render, staticRenderFns } from "./AMASComparableFinder.vue?vue&type=template&id=95137892&"
import script from "./AMASComparableFinder.vue?vue&type=script&lang=js&"
export * from "./AMASComparableFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports